import { UserAuthentified } from './user-authentified.interface';

/**
 * Sous-ensemble minimal de `UserAuthentified` permettant de situer un utilisateur
 * par rapport au client principal de son compte. Accepte aussi bien l'utilisateur
 * connecté qu'une entité quelconque manipulée côté DAO.
 */
type AccountIdentity = Pick<
  UserAuthentified,
  'id' | 'isMainAccountUser' | 'accountMainUserId'
>;

/** Vrai si l'utilisateur est le client principal de son compte. */
export const isMainAccountUser = (user?: AccountIdentity | null): boolean =>
  !!user?.isMainAccountUser;

/**
 * Vrai si l'utilisateur est le conjoint (≠ client principal). `false` si l'objet
 * est absent : sans utilisateur, il n'y a pas de conjoint.
 */
export const isSpouse = (user?: AccountIdentity | null): boolean =>
  !!user && !user.isMainAccountUser;

/**
 * Id du client principal du compte, que `user` soit lui-même le principal ou le
 * conjoint. `null` si l'utilisateur est absent ou si l'id principal est inconnu.
 */
export const mainAccountUserIdOf = (
  user?: AccountIdentity | null,
): number | null => {
  if (!user) {
    return null;
  }
  return user.isMainAccountUser ? user.id : (user.accountMainUserId ?? null);
};

export const isSameAuthSession = (
  a?: UserAuthentified | null,
  b?: UserAuthentified | null,
): boolean =>
  a?.id === b?.id &&
  a?.accountId === b?.accountId &&
  !!a?.sessionConsultant === !!b?.sessionConsultant &&
  a?.sessionConsultant?.sessionStartDate ===
    b?.sessionConsultant?.sessionStartDate;
